import React from "react";
import qs from "query-string";
import CWBLabsActorVerifyPhoneStep from "components/CWBLabs/ActorVerifyPhoneStep";
import ActorVerifyPhoneStep from "./ActorVerifyPhoneStep";

interface Props {
  t?: any;
  history?: any;
  location?: any;
}
const ActorVerifyPhoneStepHOC: React.FC<Props> = ({ location, history }) => {

  // const isCwbLabs = qs.parse(location.search).cwblabs;
  const isCwbLabs = false;
  return isCwbLabs ? (
    <CWBLabsActorVerifyPhoneStep history={history} location={location} />
  ) : (
    <ActorVerifyPhoneStep history={history} location={location} />
  );
};

export default ActorVerifyPhoneStepHOC;
